"use strict";

exports.__esModule = true;
exports.DeviceMapElement = DeviceMapElement;
var _react = _interopRequireDefault(require("react"));
var _api = require("@react-google-maps/api");
var _Core = require("../../Core");
var _DeviceListContext = require("../../Device/DeviceListContext");
var _EnvContext = require("../../Env/EnvContext");
var _MapElement = require("./MapElement");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Displays a particular property of a device, e.g. name or uuid.
 */
function DeviceMapElement(props) {
  var height = props.height,
    width = props.width;
  var env = _react["default"].useContext(_EnvContext.EnvContext);
  var deviceList = _react["default"].useContext(_DeviceListContext.DeviceListContext);
  var _useLoadScript = (0, _api.useLoadScript)({
      googleMapsApiKey: env.googleMapAPIKey || undefined,
      id: "maps"
    }),
    isLoaded = _useLoadScript.isLoaded,
    loadError = _useLoadScript.loadError;
  var renderMap = function renderMap() {
    return /*#__PURE__*/_react["default"].createElement(_MapElement.MapElement, {
      deviceList: deviceList,
      height: height,
      width: width
    });
  };
  if (loadError) {
    return /*#__PURE__*/_react["default"].createElement(_Core.UhOh, {
      error: new Error("Error loading maps.")
    });
  }
  if (!isLoaded) {
    return /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null);
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: width,
      height: height
    }
  }, renderMap());
}